// extracted by mini-css-extract-plugin
export default {"cls1":"VeloCardForm-Header_cls1__Gq9qn","cls2":"VeloCardForm-Header_cls2__Q2W65 VeloCardForm-Header_cls1__Gq9qn"};